export default //process.env.NODE_ENV === "production" ?
"https://formzine-api.artbyform.com";
//: "http://localhost:9339";
